import React from "react";
import MotionCard from "./MotionCard";
import Features from "./Feature";
import { InteractiveHoverButton } from "./InteractiveHoverButton.tsx";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const AboutIntro = () => {
  return (
    <div className="container  mx-auto px-4 sm:px-6 lg:px-12 flex flex-col lg:flex-row items-center gap-10 py-12 overflow-x-hidden">
      {/* Left Side */}
      <div className="flex-1">
        {/* Heading + Paragraph */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}>
          <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold leading-snug">
            Premium Towels for Your Business
          </h1>
          <p className="text-base sm:text-lg mt-4 text-gray-700">
            Mansafa, a proud product of EMMEF TEX, is a trusted wholesale
            supplier and exporter of premium textiles. Since 1985, we have been
            recognized for quality, craftsmanship, reliability, and innovation.
            With decades of expertise, we combine traditional excellence with
            modern sustainability to consistently deliver products that meet
            global standards.
          </p>
        </motion.div>

        {/* Features */}
        <motion.div
          className="mt-8"
          initial={{ scale: 0.8, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: false, amount: 0.3 }}>
          <Features />
        </motion.div>

        {/* Buttons */}
        <motion.div
          className="mt-8 flex flex-wrap gap-4 "
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.7, ease: "easeOut", delay: 0.4 }}
          viewport={{ once: false, amount: 0.3 }}>
          <Link to="/collection" >
            <InteractiveHoverButton hoverText="Product">
              Explore
            </InteractiveHoverButton>
          </Link>
          <Link to="/catalogue">
            <InteractiveHoverButton hoverText="Catalogue">
              View
            </InteractiveHoverButton>
          </Link>
        </motion.div>
      </div>

      {/* Right Side: MotionCard */}
      <motion.div
        className="flex-1 flex justify-center ml-8 "
        initial={{ x: -120, scale: 0.9, opacity: 0 }}
        whileInView={{ x: 0, scale: 1, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        viewport={{ once: false, amount: 0.3 }}>
        <MotionCard />
      </motion.div>
    </div>
  );
};

export default AboutIntro;
